import { render, staticRenderFns } from "./NoticeList.vue?vue&type=template&id=a3317ae4&scoped=true"
import script from "./NoticeList.vue?vue&type=script&lang=ts"
export * from "./NoticeList.vue?vue&type=script&lang=ts"
import style0 from "./NoticeList.vue?vue&type=style&index=0&id=a3317ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3317ae4",
  null
  
)

export default component.exports